<div class="asset-details-columns h-full">
  <div class="asset-details-main-column widget-bg-color rounded-xl">
    <!-- Asset preview, the image, video, ... -->
    <thehubz-asset-view [data]="assetInfo"></thehubz-asset-view>
  </div>
  <div class="asset-details-aside-column widget-bg-color rounded-xl">
    <!-- Metadata view -->
    <thehubz-asset-metadata
      *ngIf="assetInfo && assetInfo._id"
      class="flex h-full flex-col justify-between"
      (stateChange)="stateUpdate($event)"
      [asset]="assetInfo"
      [assetInfoObject]="assetInfoObject"
    ></thehubz-asset-metadata>
  </div>
</div>
